import React from 'react';
import { Box, Typography, useTheme, Grid, List, ListItem, ListItemText, LinearProgress } from '@mui/material';
import { Public, VpnLock, Map } from '@mui/icons-material';
import ReactApexChart from 'react-apexcharts';

const WidgetHeader = ({ title, icon: Icon }) => {
    const theme = useTheme();
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            {Icon && <Icon sx={{ color: theme.palette.text.secondary }} />}
            <Typography variant="h6" fontWeight="bold">
                {title}
            </Typography>
        </Box>
    );
};

const LocationAnalytics = ({ data }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const labelColor = theme.palette.text.secondary;

    const topCountries = data?.topCountries || [];
    const timezones = data?.timezones || [];
    
    // Top Countries Bar Chart
    const countrySeries = [{
        name: 'Users',
        data: topCountries.map(c => c.count)
    }];
    const countryLabels = topCountries.map(c => c._id || 'Unknown');

    const countryOptions = {
        chart: { type: 'bar', toolbar: { show: false }, background: 'transparent' },
        plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: '60%' } },
        xaxis: { categories: countryLabels, labels: { style: { colors: labelColor } } },
        yaxis: { labels: { style: { colors: labelColor } } },
        colors: [theme.palette.info.main],
        grid: { show: false },
        tooltip: { theme: isDark ? 'dark' : 'light' }
    };

    return (
        <Box sx={{ p: 2, borderRadius: 3, border: `1px solid ${theme.palette.divider}`, height: '100%' }}>
            <WidgetHeader title="Geo-Location" icon={Public} />
            
            <Grid container spacing={2}>
                 {/* <Grid item xs={12}>
                    <Box sx={{ p: 2, bgcolor: theme.palette.error.light, color: theme.palette.error.contrastText, borderRadius: 2, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="body2" sx={{ opacity: 0.9 }}>Suspicious IPs Detected</Typography>
                            <Typography variant="h5" fontWeight="bold">{data?.suspiciousIPs || 0}</Typography>
                        </Box>
                        <VpnLock />
                    </Box>
                </Grid> */}

                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>Top Countries</Typography>
                    <Box sx={{ minHeight: 200 }}>
                        <ReactApexChart options={countryOptions} series={countrySeries} type="bar" height={200} />
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>User Timezones</Typography>
                    <List dense disablePadding>
                        {timezones.slice(0, 6).map((tz, index) => (
                            <ListItem key={index} disableGutters>
                                <ListItemText 
                                    primary={tz._id || 'Unknown'} 
                                    secondary={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <LinearProgress variant="determinate" value={(tz.count / (timezones[0]?.count || 1)) * 100} sx={{ flexGrow: 1, height: 6, borderRadius: 3 }} />
                                            <Typography variant="caption">{tz.count}</Typography>
                                        </Box>
                                    }
                                />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LocationAnalytics;
